module.exports = __webpack_public_path__ + "img/6.c2dda769.jpg";